var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bags-template',{attrs:{"eye-bags":_vm.eyeBags,"eye-bags-ai-selected":_vm.eyeBagsAiSelected,"eye-bags-type":_vm.eyeBagsType,"field-errors":_vm.fieldErrors,"is-eye-bags-type-visible":_vm.isEyeBagsTypeVisible},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }